module.exports = __webpack_public_path__ + "static/media/20.3556d909.png";